import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import { useTheme } from '@mui/material/styles';
import managementService from '../../../services/AdminManagementService';
import { Box, CircularProgress, Button, Select, InputLabel, MenuItem, Input } from '@mui/material';
import { LookupUserDTOV1 } from "@beable/roster-backend-client-v1";
import { emptyUserProfile } from '../fixtures';
import { getStyles } from './styles';

function getModalStyle() {
    return {
        top: `35vh`,
        left: `37.5vw`,
    };
}

type ImpersonateUserModalProps = {
    profile: LookupUserDTOV1;
    open: boolean;
    handleClose: () => void;
};

export default function ImpersonateUserModal(props: ImpersonateUserModalProps) {

    const theme = useTheme();
    const styles = getStyles(theme);
    const [modalStyle] = useState(getModalStyle);
    const [profile, setProfile] = useState(emptyUserProfile);

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [selectedReasonIndex, setSelectedReasonIndex] = useState(0);
    const [impersonateReason, setImpersonateReason] = useState('User support');
    const [currentStatus, setCurrentStatus] = useState('');

    useEffect(() => {
        setProfile(props.profile);
    }, [props.profile]);

    const resetState = () => {
        setIsLoading(false);
        setIsError(false);
        setCurrentStatus('');
    };

    const handleSelectChange = async (e: any) => {
        try {
            setSelectedReasonIndex(e.target.value);

            const tempSelectedValue = Number(e.target.value);
            
            if(tempSelectedValue === 0) setImpersonateReason('User support');
            if(tempSelectedValue === 1) setImpersonateReason('Testing');
            if(tempSelectedValue === 2) setImpersonateReason('');
            
        } catch (error) {
            console.log(error);
            setIsError(true);
        }
    }

    const handleReasonDetail = (e: any) => {
        setImpersonateReason(e.target.value);
    }

    const handleLaunch = async (e: any) => {
        try {
            setIsLoading(true);
            setCurrentStatus('Generating admin authentication ticket...');

            if(!impersonateReason) {
                setIsLoading(false);
                setCurrentStatus('The impersonate reason can\'t be empty');
                return;
            }

            const adminImpersonateTicket = await managementService.getAdminImpersonateTicket(
                profile.siteId,
                profile.userId,
                impersonateReason
            );

            if (adminImpersonateTicket) {
                setCurrentStatus('Admin ticket acquired. Ready to launch impersonation');
                setIsLoading(false);

                const authURL = `${process.env.REACT_APP_BEABLE_LITERACY_BACKEND_URL}/login/impersonate/${adminImpersonateTicket}`;
                window.open(authURL, '_blank', 'noopener,noreferrer');
                resetState();
                props.handleClose();

            } else {
                setCurrentStatus('Could not get the admin authentication ticket');
                setIsLoading(false);
                setIsError(true);
            }
        } catch (error) {
            setIsError(true);
        }
    }

    return (
        <Modal
            aria-labelledby="admin-impersonate-modal-title"
            aria-describedby="admin-impersonate-modal-description"
            open={props.open}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    props.handleClose();
                }
            }}
        >
            <Box sx={{ ...modalStyle, ...styles.impersonatePaper }}>
                <h2 id="admin-impersonate-modal-title">Impersonating -  {profile && profile.username ? profile.username : " "}</h2>
                <p id="admin-impersonate-modal-description">Remember to be careful when using real user accounts. The data generated in the session will reach reporting. The impersonation sessions are logged.</p>
                <InputLabel id="impersonate-select-label">Impersonate Reason:</InputLabel>
                <Select
                    variant="standard"
                    onChange={handleSelectChange}
                    value={selectedReasonIndex}>
                    <MenuItem key="0" value="0">User Support</MenuItem>
                    <MenuItem key="1" value="1">Testing</MenuItem>
                    <MenuItem key="2" value="2">Other</MenuItem>
                </Select>
                <br />
                {selectedReasonIndex === 2 && <br /> }
                {selectedReasonIndex === 2 && <InputLabel id="impersonate-detail-reason">Reason:</InputLabel>}
                {selectedReasonIndex === 2 && 
                    <Input
                        name="detailReason"
                        id="detailReason"
                        aria-describedby="Impersonate detail reason"
                        fullWidth
                        onChange={handleReasonDetail}
                    />
                }
                <br />
                {isLoading ? <CircularProgress test-id="admin-impersonate-loader" disableShrink /> : null}
                <br />
                {isError ? <p>There was an error generating the admin authentication ticket</p> : null}
                <br />
                {currentStatus ? <p>Status: {currentStatus}</p> : null}
                <br />
                <Button variant="contained" color="primary" onClick={handleLaunch} disabled={isError || isLoading} type="submit">Open Literacy</Button>
                <Button variant="contained" onClick={props.handleClose} sx={styles.ml2}>Close</Button>
            </Box>
        </Modal>
    );
}